import React, { useState } from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import type { AssociatedIssue } from '@atlassian/jira-portfolio-3-associated-issues';
import IdeaIssue from './idea-issue';
import IdeasCellSelect from './ideas-cell-select';
import { calculateFlexShrink } from './utils';

type Props = {
	associatedIssues: AssociatedIssue[];
	isReadOnly?: boolean;
	isDisabled?: boolean;
	isExportMode?: boolean;
};

export const IdeasCell = ({ associatedIssues, isDisabled, isReadOnly, isExportMode }: Props) => {
	const isReadonlyMode = isDisabled || isReadOnly || isExportMode;
	const [ideasToRender, setIdeasToRender] = useState(associatedIssues);

	const updateIdeas = () => {
		// This is a mock for the next step, keep it to remember about
		setIdeasToRender([...ideasToRender]);
	};

	const renderMultipleIdeas = () => {
		const names = ideasToRender.map((el) => el.summary);
		const values = calculateFlexShrink(names);

		return (
			<>
				{ideasToRender.map((associatedIssue, index) => (
					<IdeaIssue key={associatedIssue.key} data={associatedIssue} flexShrink={values[index]} />
				))}
			</>
		);
	};

	return (
		<Box>
			{isReadonlyMode ? (
				<Flex>{renderMultipleIdeas()}</Flex>
			) : (
				<IdeasCellSelect
					renderMultipleIdeas={renderMultipleIdeas}
					currentAssociatedIssues={associatedIssues}
					updateIdeas={updateIdeas}
				/>
			)}
		</Box>
	);
};
